import { useState } from "react";
import { Dialog, DialogActions, DialogContent, Button, IconButton } from "@mui/material";
import OrganizationProfileStepper from "./organization-profile-stepper";
import useOrganizationProfileStepper from "hooks/useOrganizationProfileStepper";
import { useSelector } from "react-redux";
import { LoadingButton } from "@mui/lab";
import { Close } from "@mui/icons-material";

const OnboardingPopup = ({ 
    open, 
    onClose,
    doNotShowAgain,
    onNotShowAgainClick,
    isSavingRemainder
}) => {
    const [actionVisible, setActionVisible] = useState(true);
    const { submitUpdate, isReady } = useOrganizationProfileStepper({ enabled: open });

    const saving = useSelector(
        (state) => state.organizationStepperState.saving
    );

    const handleDialogClose = (event, reason) => {
        if (reason === "backdropClick") {
            return;
        }
        onClose(event, reason);
    };

    return (
        <Dialog
            open={open}
            onClose={handleDialogClose}
            fullWidth
            maxWidth="lg"
            sx={{
                "& .MuiDialog-paper": {
                    py: 0,
                },
            }}
        >
             <IconButton
                aria-label="close"
                onClick={onClose}
                sx={{
                    position: "absolute",
                    right: 8,
                    top: 4,
                    zIndex: 15
                }}
            >
                <Close />
            </IconButton>

            <DialogContent dividers sx={{ p: 0 }}>
                <OrganizationProfileStepper
                    complete={false}
                    popupMode={true}
                    onComplete={() => submitUpdate()}
                    actionsDisabled={!isReady}
                />
            </DialogContent>
            {actionVisible && (
                <DialogActions>
                    {doNotShowAgain && (
                        <LoadingButton 
                            color="secondary" 
                            variant="outlined" 
                            loading={isSavingRemainder}
                            onClick={onNotShowAgainClick}
                        >
                            Don't show again
                        </LoadingButton>
                    )}

                    <LoadingButton color="secondary" variant="outlined" 
                        loading={isSavingRemainder}
                        onClick={onClose}
                    >
                        Remind me later
                    </LoadingButton>

                    <LoadingButton color="secondary" variant="outlined"
                        loading={saving}
                        disabled={!isReady}
                        onClick={() => {
                            submitUpdate().then((success) => {
                                if (success) {
                                    onClose();
                                }
                            });
                        }}
                    >
                        Save
                    </LoadingButton>

                </DialogActions>
            )}
        </Dialog>
    );
};

export default OnboardingPopup;
